import { forwardRef, useRef } from 'react';
import { useLink } from 'react-aria';
import PropTypes from 'prop-types';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Link.module.scss';

// https://react-spectrum.adobe.com/react-aria/useLink.html

// eslint-disable-next-line react/display-name
const Link = forwardRef(({ children, className, href, target, isError, isDisabled, visited, rel, inverse, lang, underline, variant, ...props }, ref) => {
    const defaultRef = useRef();
    const linkRef = ref || defaultRef;

    const { linkProps, isPressed } = useLink(props, ref);

    return (
        <a
            data-testid={props['data-testid']}
            {...linkProps}
            ref={linkRef}
            className={[
                'govuk-link',
                styles.link,
                variant ? styles[variant] : null,
                isPressed ? styles.pressed : null,
                isDisabled ? styles.disabled : null,
                visited ? 'govuk-link--no-visited-state' : null,
                inverse ? 'govuk-link--inverse' : null,
                underline ? null : 'govuk-link--no-underline',
                isError ? styles.error : null,
                className
            ].join(' ')}
            href={href}
            target={target}
            tabIndex={ isDisabled ? -1 : 0 }
            rel={rel}
            lang={lang}
            aria-disabled={isDisabled}
            {...props}
        >
            {children}
        </a>
    );
});

Link.propTypes = {
    ...defaultAriaProps,
    className: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top', 'framename']),
    isDisabled: PropTypes.bool,
    visited: PropTypes.bool,
    rel: PropTypes.string,
    lang: PropTypes.string,
    isError: PropTypes.bool,
    variant: PropTypes.oneOf(['transparent', 'default'])
};

Link.defaultProps = {
    visited: false,
    inverse: false,
    underline: true,
    isError: false,
    variant: null
};

export default Link;
